module.exports = __webpack_public_path__ + "assets/img/img2.42f552f1.jpg";